import React from "react";
import { Button } from "../Button/Button";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../utils/base_url";
import { Carousel } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import icon1 from "../../assets/icons/authenticicon.png";
import { MarkdownComponent } from "../../layouts/FormLayout";
import {
  _1200px,
  _1400px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";

const HeroComponent = ({
  // bgImage,
  // subTitle,
  // mainHeading,
  // tagLine,
  // buttons = [],
  // bgImages,
  // bgVideos,
  carousel,
  topEvents,
}) => {
  // console.log(carousel[0]);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(max-width: 1098px)",
  });
  return (
    <>
      <div className="row" style={{ background: "rgb(9, 13, 35)" }}>
        <Carousel
          pause={false}
          indicators={false}
          interval={5000}
          controls={false}
        >
          {carousel?.map((image, idx) => (
            <Carousel.Item key={idx} className="position-relative vh-100">
              {image?.background?.mime?.includes("video") ? (
                <div className="vh-100">
                  <video
                    autoPlay
                    loop
                    muted
                    width={"100%"}
                    className="vh-100"
                    style={{ objectFit: "cover" }}
                  >
                    <source
                      src={`${baseUrl}${image?.background?.url}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <img
                  className="d-block w-100 vh-100"
                  style={{ objectFit: "cover" }}
                  src={`${baseUrl}${image?.background?.url}`}
                  alt="..."
                />
              )}

              <CaptionComponent
                mainHeading={image?.heading}
                buttons={image?.CTAs}
                subTitle={image?.sub_heading}
                tagLine={image?.tagline}
                isDesktopOrLaptop={isDesktopOrLaptop}
              />
            </Carousel.Item>
          ))}
          {/* {bgImages?.map((image, idx) => (
            <Carousel.Item key={idx} className="position-relative">
              <img
                className="d-block w-100"
                src={`${baseUrl}${image.url}`}
                alt="..."
              />
              <CaptionComponent
                mainHeading={mainHeading}
                buttons={buttons}
                subTitle={subTitle}
                tagLine={tagLine}
                isDesktopOrLaptop={isDesktopOrLaptop}
              />
            </Carousel.Item>
          ))} */}
          {/* {bgVideos?.map((video, idx) => (
            <Carousel.Item key={idx} className="position-relative ">
              <video autoPlay loop muted width="100%" height="100%">
                <source src={`${baseUrl}${video?.url}`} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <CaptionComponent
                mainHeading={mainHeading}
                buttons={buttons}
                subTitle={subTitle}
                tagLine={tagLine}
                isDesktopOrLaptop={isDesktopOrLaptop}
              />
            </Carousel.Item>
          ))} */}
        </Carousel>
        {/* <div id="carouselExample" className="carousel slide">
          <div className="carousel-inner">
            {bgImages?.map((image, idx) => (
              <div className={`carousel-item ${idx === 0 && "active"}`}>
                <img
                  src={`${baseUrl}${image?.url}`}
                  className="d-block w-100"
                  alt="..."
                />

                <CaptionComponent
                  mainHeading={mainHeading}
                  buttons={buttons}
                  subTitle={subTitle}
                  tagLine={tagLine}
                />
              </div>
            ))}

            {bgVideos?.map((video, idx) => (
              <div className={`carousel-item ${idx === 0 && "active"}`}>
                <video autoPlay loop muted width="100%" height="100%">
                  <source src={`${baseUrl}${video?.url}`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <CaptionComponent
                  mainHeading={mainHeading}
                  buttons={buttons}
                  subTitle={subTitle}
                  tagLine={tagLine}
                />
              </div>
            ))}
          </div>
        </div> */}
        {/* <div
          style={{
            // backgroundImage: `url(${bgImage})`,
            backgroundRepeat: " no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div
            className="d-flex flex-column gap-5 align-items-center   w-100 h-100"
            style={{
              background: "rgba(21, 26, 78, 0.7)",
              paddingTop: "6%",
            }}
          >
            <span className="fs-5 fw-semibold text-white">{tagLine}</span>
            <p className="display-3 fw-bolder text-white  text-center hero-heading px-3 px-md-0">
              {mainHeading}
            </p>

            <p className="fs-4 fw-normal  text-center text-white hero-subtitle">
              {subTitle}
            </p>

            <div className="d-flex align-items-center gap-3  flex-column flex-md-row mb-5">
              {buttons?.map((data, idx) => (
                <React.Fragment key={idx}>
                  <Button
                    textColor={data?.textColor}
                    background={
                      data?.backgroundColor
                        ? data?.backgroundColor
                        : "transparent"
                    }
                    className={`${data?.backgroundColor ? "" : "border"} px-5`}
                    onClick={() => navigate(data?.url)}
                  >
                    {data?.text}
                  </Button>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div> */}

        {/* <div className="col-12 z-1" style={{ marginTop: "-15rem" }}>
          <div
            className="row d-flex justify-content-center gx-3   "
            style={{ gap: "6rem" }}
          >
            {topEvents?.events?.map((data, idx) => (
              <div key={idx} className="col-lg-2">
                <CurvedBox data={data} />
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </>
  );
};

const CaptionComponent = ({
  mainHeading,
  tagLine,
  subTitle,
  buttons,
  isDesktopOrLaptop,
}) => {
  const navigate = useNavigate();
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <div
      className="carousel-caption d-flex flex-column justify-content-end pb-5 position-absolute top-0 start-0 w-100 "
      style={{
        padding: "0rem",
        background: "rgba(21, 26, 78, 0.5)",
        height: "100%",
        // paddingLeft: isDesktopOrLaptop ? "3rem" : "10rem",
        // paddingTop: isDesktopOrLaptop ? "1rem" : "2rem",
      }}
    >
      <div className="d-flex flex-column align-items-start pb-5">
        <div className="container contwidth px-0">
          {/* <span className="fs-5 fw-semibold text-white">{tagLine}</span> */}
          <p
            dangerouslySetInnerHTML={{
              __html: mainHeading?.replace(/Revolutionizing n/g, "Revolutionizing <br/>"),
            }}
            className={`fw800 lh-sm text-white text-start px-lg-0 mb-4`}
            style={{
              // lineHeight: "5rem",
              fontSize: _576
                ? "30px"
                : _768
                ? "55px"
                : _992
                ? "60px"
                : _1200
                ? "60px"
                : _1400
                ? "65px"
                : _1600
                ? "75px"
                : _1700
                ? "75px"
                : _1800
                ? "80px"
                : "80px",
            }}
          >
            {/* {mainHeading} */}
          </p>

          {/* <p
            dangerouslySetInnerHTML={{
              __html: subTitle?.replace(/Contract n/g, "Contract <br/>"),
            }}
            className="fw500 text-start text-white mb-4 lh-sm px-lg-0"
            style={{
              lineHeight: "3rem",
              fontSize: _576
                ? "20px"
                : _768
                ? "28px"
                : _992
                ? "28px"
                : _1200
                ? "30px"
                : _1400
                ? "30px"
                : _1600
                ? "33px"
                : _1700
                ? "35px"
                : _1800
                ? "40px"
                : "40px",
            }}
          >
          </p> */}

          {/* <div className="mb-5 text-start">
            {buttons?.map((data, idx) => (
              <React.Fragment key={idx}>
                <Button
                  textColor={data?.textColor}
                  background={
                    data?.backgroundColor
                      ? data?.backgroundColor
                      : "transparent"
                  }
                  newButtonClassName={`${
                    _1200
                      ? "fs16"
                      : _1400
                      ? "fs18"
                      : _1700
                      ? "fs20"
                      : _1800
                      ? "fs20"
                      : "fs20"
                  } border-0 rounded-3 py-2 py-md-3 px-3 px-md-5 `}
                  onClick={() => navigate(data?.url)}
                >
                  {data?.text}
                </Button>
              </React.Fragment>
            ))}
          </div> */}
        </div>
      </div>
    </div>
  );
};

const CurvedBox = ({ data }) => {
  return (
    <>
      <div
        className="d-flex flex-column gap-2  text-white pb-2 pt-5 px-4"
        style={{
          background: "linear-gradient(180deg, #0039EC 0%, #0D1437 100%)",
          borderTopRightRadius: "100px",
          border: "2px solid #FFFFFF",
        }}
      >
        <img src={`${baseUrl}${data?.image?.url}`} alt="" width={40} />
        <MarkdownComponent markdown={data?.description} />
        <div style={{ border: "2px solid white" }} />
        <span className="mt-1 fs14 fw-light">{data?.sub_text}</span>
      </div>
    </>
  );
};
export default HeroComponent;
